import React from 'react'
import {Box} from '@mui/material'
import {
  buildPrintTemplateContext, PrintOrderData, renderPrintTemplate} from '@/modules/settings/utils/printTemplate'
import { DEFAULT_PRINT_ORDER_SETTINGS } from '@/modules/settings/templates/defaultPrintOrderSettings'
import { PrintOrderSettings } from '@/modules/settings/types/printOrder'
import { getPrintOrderSettings } from '@/modules/settings/redux/SettingsCRUD'

type OrderPrintTemplateRuntimeProps = {
  orderData: PrintOrderData
  settingsOverride?: PrintOrderSettings
  printType?: string
  onReady?: () => void
}

const OrderPrintTemplateRuntime: React.FC<OrderPrintTemplateRuntimeProps> = ({orderData, settingsOverride, printType, onReady}) => {
  const [settings, setSettings] = React.useState<PrintOrderSettings>(settingsOverride || DEFAULT_PRINT_ORDER_SETTINGS)

  React.useEffect(() => {
    if (settingsOverride) {
      setSettings(settingsOverride)
      onReady?.()
      return
    }

    let mounted = true
    getPrintOrderSettings(printType)
      .then((data) => {
        if (mounted) {
          setSettings(data)
          onReady?.()
        }
      })
      .catch(() => {
        if (mounted) {
          setSettings(DEFAULT_PRINT_ORDER_SETTINGS)
          onReady?.()
        }
      })

    return () => {
      mounted = false
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [settingsOverride, printType])

  const html = React.useMemo(() => {
    const context = buildPrintTemplateContext(orderData, settings)
    return renderPrintTemplate(settings.template_html, context)
  }, [orderData, settings])

  return (
    <Box
      className='print-container'
      sx={{
        width: '300mm',
        minHeight: '297mm',
        padding: '15mm',
        backgroundColor: 'white',
        '@media print': {
          width: '100%',
          minHeight: '100%',
          padding: '0',
          margin: '0',
          boxShadow: 'none',
        },
      }}
    >
      <style>{`
        .print-container table td,
        .print-container table th {
          white-space: pre-wrap !important;
          word-break: break-word !important;
          overflow-wrap: anywhere !important;
        }
        .print-container table td:nth-child(3),
        .print-container table th:nth-child(3) {
          text-align: left !important;
        }
      `}</style>
      <div dangerouslySetInnerHTML={{__html: html}} />
    </Box>
  )
}

export default OrderPrintTemplateRuntime
